/** @jsx jsx */
// @ts-check
import { Link } from '@bottlebooks/gatsby-theme-base/src';
import { jsx } from 'theme-ui';
import './post-1128.css';

export default function Footer() {
  return (
    <div
      data-elementor-type="footer"
      data-elementor-id={1128}
      className="elementor elementor-1128 elementor-location-footer elementor-kit-39"
      data-elementor-settings="[]"
    >
      <div className="elementor-section-wrap">
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-4537e2e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="4537e2e"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-custom">
            <div
              className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-4be252a"
              data-id="4be252a"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-6965349 elementor-widget elementor-widget-image"
                  data-id={6965349}
                  data-element_type="widget"
                  data-widget_type="image.default"
                >
                  <div className="elementor-widget-container">
                    <img
                      width={600}
                      height={254}
                      alt=""
                      data-srcset="https://northsouthwines.co.uk/wp-content/uploads/2021/07/nsw-logo-inverted.png 600w, https://northsouthwines.co.uk/wp-content/uploads/2021/07/nsw-logo-inverted-300x127.png 300w"
                      data-src="https://northsouthwines.co.uk/wp-content/uploads/2021/07/nsw-logo-inverted.png"
                      data-sizes="(max-width: 600px) 100vw, 600px"
                      className="attachment-full size-full ls-is-cached lazyloaded"
                      src="https://northsouthwines.co.uk/wp-content/uploads/2021/07/nsw-logo-inverted.png"
                      sizes="(max-width: 600px) 100vw, 600px"
                      srcSet="https://northsouthwines.co.uk/wp-content/uploads/2021/07/nsw-logo-inverted.png 600w, https://northsouthwines.co.uk/wp-content/uploads/2021/07/nsw-logo-inverted-300x127.png 300w"
                    />
                    <noscript>
                      &lt;img width="600" height="254"
                      src="https://northsouthwines.co.uk/wp-content/uploads/2021/07/nsw-logo-inverted.png"
                      class="attachment-full size-full" alt=""
                      srcset="https://northsouthwines.co.uk/wp-content/uploads/2021/07/nsw-logo-inverted.png
                      600w,
                      https://northsouthwines.co.uk/wp-content/uploads/2021/07/nsw-logo-inverted-300x127.png
                      300w" sizes="(max-width: 600px) 100vw, 600px" /&gt;
                    </noscript>{' '}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-fb1882c elementor-position-left elementor-view-default elementor-vertical-align-top elementor-widget elementor-widget-icon-box"
                  data-id="fb1882c"
                  data-element_type="widget"
                  data-widget_type="icon-box.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-icon-box-wrapper">
                      <div className="elementor-icon-box-icon">
                        <a
                          className="elementor-icon elementor-animation-"
                          href="https://www.google.com/maps/place/North+South+Wines+Ltd/@51.5038091,-0.4684416,15z/data=!4m2!3m1!1s0x0:0x43459992cee7d44f?sa=X&ved=2ahUKEwjurfWasMHxAhW5zjgGHUX8Cm4Q_BIwFnoECEMQBQ"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i
                            aria-hidden="true"
                            className="fas fa-map-marker-alt"
                          />{' '}
                        </a>
                      </div>
                      <div className="elementor-icon-box-content">
                        <div className="elementor-icon-box-title">
                          <a
                            href="https://www.google.com/maps/place/North+South+Wines+Ltd/@51.5038091,-0.4684416,15z/data=!4m2!3m1!1s0x0:0x43459992cee7d44f?sa=X&ved=2ahUKEwjurfWasMHxAhW5zjgGHUX8Cm4Q_BIwFnoECEMQBQ"
                            target="_blank"
                            rel="noreferrer"
                          ></a>
                        </div>
                        <p className="elementor-icon-box-description">
                          North South Wines
                          <br />
                          Drayton Hall, Church Rd,
                          <br />
                          West Drayton UB7 7PS,
                          <br />
                          United Kingdom{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-7aca938"
              data-id="7aca938"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-d2bea10 elementor-widget elementor-widget-heading"
                  data-id="d2bea10"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h6 className="elementor-heading-title elementor-size-default">
                      Popular pages
                    </h6>{' '}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-076cd74 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                  data-id="076cd74"
                  data-element_type="widget"
                  data-widget_type="icon-list.default"
                >
                  <div className="elementor-widget-container">
                    <Menu />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-f60e85e"
              data-id="f60e85e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-276278a elementor-widget elementor-widget-heading"
                  data-id="276278a"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h6 className="elementor-heading-title elementor-size-default">
                      Disclaimers
                    </h6>{' '}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-36ca620 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                  data-id="36ca620"
                  data-element_type="widget"
                  data-widget_type="icon-list.default"
                >
                  <div className="elementor-widget-container">
                    <ul className="elementor-icon-list-items">
                      <li className="elementor-icon-list-item">
                        <a href="https://northsouthwines.co.uk/terms-and-conditions/">
                          <span className="elementor-icon-list-icon">
                            <i
                              aria-hidden="true"
                              className="fas fa-chevron-right"
                            />{' '}
                          </span>
                          <span className="elementor-icon-list-text">
                            Terms &amp; Conditions
                          </span>
                        </a>
                      </li>
                      <li className="elementor-icon-list-item">
                        <a href="https://northsouthwines.co.uk/wp-content/uploads/2021/11/Data-Retention-Policy.pdf">
                          <span className="elementor-icon-list-icon">
                            <i
                              aria-hidden="true"
                              className="fas fa-chevron-right"
                            />{' '}
                          </span>
                          <span className="elementor-icon-list-text">
                            Data Protection Policy
                          </span>
                        </a>
                      </li>
                      <li className="elementor-icon-list-item">
                        <a
                          href="https://northsouthwines.co.uk/wp-content/uploads/2022/07/Modern-Slavery-and-Human-Trafficking-Statement-2022.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="elementor-icon-list-icon">
                            <i
                              aria-hidden="true"
                              className="fas fa-chevron-right"
                            />{' '}
                          </span>
                          <span className="elementor-icon-list-text">
                            Modern Slavery Statement
                          </span>
                        </a>
                      </li>
                      <li className="elementor-icon-list-item">
                        <a href="https://www.drinkaware.co.uk/">
                          <span className="elementor-icon-list-icon">
                            <i
                              aria-hidden="true"
                              className="fas fa-chevron-right"
                            />{' '}
                          </span>
                          <span className="elementor-icon-list-text">
                            Drink Aware
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-bbb6f35 elementor-widget elementor-widget-image"
                  data-id="bbb6f35"
                  data-element_type="widget"
                  data-widget_type="image.default"
                >
                  <div className="elementor-widget-container">
                    <a href="https://www.drinkaware.co.uk/">
                      <img
                        width={3091}
                        height={539}
                        alt=""
                        data-srcset="https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB.png 3091w, https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-300x52.png 300w, https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-1024x179.png 1024w, https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-768x134.png 768w, https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-1536x268.png 1536w, https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-2048x357.png 2048w"
                        data-src="https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB.png"
                        data-sizes="(max-width: 3091px) 100vw, 3091px"
                        className="attachment-full size-full ls-is-cached lazyloaded"
                        src="https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB.png"
                        sizes="(max-width: 3091px) 100vw, 3091px"
                        srcSet="https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB.png 3091w, https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-300x52.png 300w, https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-1024x179.png 1024w, https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-768x134.png 768w, https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-1536x268.png 1536w, https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-2048x357.png 2048w"
                      />
                      <noscript>
                        &lt;img width="3091" height="539"
                        src="https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB.png"
                        class="attachment-full size-full" alt=""
                        srcset="https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB.png
                        3091w,
                        https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-300x52.png
                        300w,
                        https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-1024x179.png
                        1024w,
                        https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-768x134.png
                        768w,
                        https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-1536x268.png
                        1536w,
                        https://northsouthwines.co.uk/wp-content/uploads/2021/05/Drinkaware_BDA_logo_Reversed_RGB-2048x357.png
                        2048w" sizes="(max-width: 3091px) 100vw, 3091px" /&gt;
                      </noscript>{' '}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-8916025"
              data-id={8916025}
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-7d420d6 elementor-widget elementor-widget-heading"
                  data-id="7d420d6"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h6 className="elementor-heading-title elementor-size-default">
                      Get in Touch
                    </h6>{' '}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-232cf7a elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                  data-id="232cf7a"
                  data-element_type="widget"
                  data-widget_type="icon-list.default"
                >
                  <div className="elementor-widget-container">
                    <ul className="elementor-icon-list-items">
                      <li className="elementor-icon-list-item">
                        <a href="tel:+442038719210">
                          <span className="elementor-icon-list-icon">
                            <i aria-hidden="true" className="fas fa-phone" />{' '}
                          </span>
                          <span className="elementor-icon-list-text">
                            Call us:
                            <br />
                            +44 (0) 20 3871 9210
                          </span>
                        </a>
                      </li>
                      <li className="elementor-icon-list-item">
                        <a href="mailto:hello@northsouthwines.co.uk">
                          <span className="elementor-icon-list-icon">
                            <i aria-hidden="true" className="far fa-envelope" />{' '}
                          </span>
                          <span className="elementor-icon-list-text">
                            Email us:
                            <br />
                            hello@northsouthwines.co.uk
                          </span>
                        </a>
                      </li>
                      <li className="elementor-icon-list-item">
                        <span className="elementor-icon-list-icon">
                          <i aria-hidden="true" className="far fa-comment" />{' '}
                        </span>
                        <span className="elementor-icon-list-text">
                          On Social Networks
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-654392c elementor-shape-square e-grid-align-left elementor-grid-0 elementor-widget elementor-widget-social-icons"
                  data-id="654392c"
                  data-element_type="widget"
                  data-widget_type="social-icons.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-social-icons-wrapper elementor-grid">
                      <span className="elementor-grid-item">
                        <a
                          className="elementor-icon elementor-social-icon elementor-social-icon-facebook-f elementor-repeater-item-f563c3b"
                          href="https://www.facebook.com/northsouthwines/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="elementor-screen-only">
                            Facebook-f
                          </span>
                          <i className="fab fa-facebook-f" />{' '}
                        </a>
                      </span>
                      <span className="elementor-grid-item">
                        <a
                          className="elementor-icon elementor-social-icon elementor-social-icon-twitter elementor-repeater-item-30829bb"
                          href="https://twitter.com/northsouthwines"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="elementor-screen-only">Twitter</span>
                          <i className="fab fa-twitter" />{' '}
                        </a>
                      </span>
                      <span className="elementor-grid-item">
                        <a
                          className="elementor-icon elementor-social-icon elementor-social-icon-instagram elementor-repeater-item-5d55af7"
                          href="https://www.instagram.com/northsouthwines_uk/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="elementor-screen-only">
                            Instagram
                          </span>
                          <i className="fab fa-instagram" />{' '}
                        </a>
                      </span>
                      <span className="elementor-grid-item">
                        <a
                          className="elementor-icon elementor-social-icon elementor-social-icon-linkedin-in elementor-repeater-item-7cdce93"
                          href="https://www.linkedin.com/company/north-south-wines-uk/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="elementor-screen-only">
                            Linkedin-in
                          </span>
                          <i className="fab fa-linkedin-in" />{' '}
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-97874c2 elementor-widget elementor-widget-text-editor"
                  data-id="97874c2"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <h6>
                      <span style={{ color: 'rgba(255, 255, 255, 0.77)' }}>
                        Website by
                      </span>{' '}
                      <a href="https://cld.agency/">CLD Agency</a>
                    </h6>{' '}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

function Menu() {
  return (
    <ul className="elementor-icon-list-items">
      <li className="elementor-icon-list-item">
        <a href="https://northsouthwines.co.uk/contact-us/">
          <span className="elementor-icon-list-icon">
            <i aria-hidden="true" className="far fa-comments" />{' '}
          </span>
          <span className="elementor-icon-list-text">Contact</span>
        </a>
      </li>
      <li className="elementor-icon-list-item">
        <Link to="/producers">
          <span className="elementor-icon-list-icon">
            <i aria-hidden="true" className="fas fa-heart" />{' '}
          </span>
          <span className="elementor-icon-list-text">Partners</span>
        </Link>
      </li>
      <li className="elementor-icon-list-item">
        <Link to="/products">
          <span className="elementor-icon-list-icon">
            <i aria-hidden="true" className="fas fa-wine-bottle" />{' '}
          </span>
          <span className="elementor-icon-list-text">Products</span>
        </Link>
      </li>
      <li className="elementor-icon-list-item">
        <a href="https://northsouthwines.co.uk/about-us/">
          <span className="elementor-icon-list-icon">
            <i aria-hidden="true" className="fas fa-book-open" />{' '}
          </span>
          <span className="elementor-icon-list-text">About Us</span>
        </a>
      </li>
      <li className="elementor-icon-list-item">
        <a href="https://northsouthwines.co.uk/blog/">
          <span className="elementor-icon-list-icon">
            <i aria-hidden="true" className="fas fa-bookmark" />{' '}
          </span>
          <span className="elementor-icon-list-text">News &amp; Blog</span>
        </a>
      </li>
      <li className="elementor-icon-list-item">
        <a href="https://northsouthwines.co.uk">
          <span className="elementor-icon-list-icon">
            <i aria-hidden="true" className="fas fa-home" />{' '}
          </span>
          <span className="elementor-icon-list-text">North South Wines</span>
        </a>
      </li>
    </ul>
  );
}
